<template>
  <div>
    <v-dialog v-model="message.status" fullscreen>
      <v-alert
        class="mx-auto my-12"
        max-width="374"
        v-model="message.status"
        dismissible
        prominent
        shaped
        :type="message.color"
      >{{ message.text }}
      </v-alert>
    </v-dialog>
    <v-tabs vertical>
      <v-tab v-for="permission in permissions" style="width: 200px" :key="permission.group">
        {{ permission.group }}
      </v-tab>
      <v-tab-item v-for="permission in permissions" :key="permission.group">
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12"
                   xl="12">
              <v-card
                elevation="1"
                :loading="loading"
                shaped
              >
                <v-card-title>
                  <h4>مجوز مسیر های گروه {{ permission.group }}</h4>
                </v-card-title>
                <v-card-text>
                  <v-simple-table>
                    <thead>
                    <tr>
                      <th>
                        آدرس مسیر
                      </th>
                      <th>
                        ایجاد
                      </th>
                      <th>
                        خواندن
                      </th>
                      <th>
                        ویرایش
                      </th>
                      <th>
                        حذف
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="page in permission.pages">
                      <td>
                        {{ page.uri }}
                      </td>
                      <td>
                        <template v-if="page.method==='POST'">
                          <v-switch
                            v-if="page.method==='POST'"
                            v-model="page.model"
                            inset
                          ></v-switch>
                        </template>
                        <v-switch
                          v-else
                          disabled
                          inset
                        ></v-switch>
                      </td>
                      <td>
                        <template v-if="page.method==='GET' || page.method==='GET|POST'">
                          <v-switch
                            v-if="page.method==='GET' || page.method==='GET|POST'"
                            v-model="page.model"
                            inset
                          ></v-switch>
                        </template>
                        <v-switch
                          v-else
                          disabled
                          inset
                        ></v-switch>
                      </td>
                      <td>
                        <template v-if="page.method==='PUT'">
                          <v-switch
                            v-if="page.method==='PUT'"
                            v-model="page.model"
                            inset
                          ></v-switch>
                        </template>
                        <v-switch
                          v-else
                          disabled
                          inset
                        ></v-switch>
                      </td>
                      <td>
                        <template v-if="page.method==='DELETE'">
                          <v-switch
                            v-if="page.method==='DELETE'"
                            v-model="page.model"
                            inset
                          ></v-switch>
                        </template>
                        <v-switch
                          v-else
                          disabled
                          inset
                        ></v-switch>
                      </td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <v-btn
      color="primary"
      elevation="3"
      rounded
      x-large
      fixed
      bottom
      left
      class="mb-8"
      style="z-index: 9999"
      @click="returnPermission"
    >
      ذخیره مسیرهای نقش "{{ $route.params.role }}"
    </v-btn>
  </div>

</template>

<script>
import axios from "@axios";
import router from "@/router";
import baseConfig from "@/../baseConfig";

export default {
  name: 'Route',
  beforeCreate() {
    if (localStorage.getItem("accessToken")==="undefined" || localStorage.getItem("accessToken")===undefined || localStorage.getItem("accessToken")==="null" || localStorage.getItem("accessToken")===null || localStorage.getItem("accessToken")==="") {
      router.push('/login')
    }
  },
  data: () => (
    {
      loading:false,
      message: {
        status: false,
        text: "success operation",
        color: "success"
      },
      permissions: [],
      permissionsAssigned: [],
    }),
  async mounted() {
    await axios.get(baseConfig.baseUrl+'panel/permissions/getRoutes').then(r => {
      this.permissions = r.data
    })

    await axios.get(baseConfig.baseUrl+'panel/roles/getRolePermissions/'+ this.$route.params.role+"/"+this.$route.params.id).then(r2 => {
      this.permissionsAssigned = r2.data.data
    //  console.log(this.permissions)
      this.permissions.map(g => g.pages.map(p=>  this.permissionsAssigned.includes(p.permissionName) ? p.model=true : p.model=false));
    })
  }
  ,
  methods: {
    async returnPermission() {
      this.loading=true
      let sendResult = [];
      let sendResultUnPermission = [];
      this.permissions.map(p => p.pages.map(r => r.model === true ? sendResult.push(r.permissionName) : null))
      this.permissions.map(p => p.pages.map(r => r.model === false ? sendResultUnPermission.push(r.permissionName) : null))
      await axios.post(baseConfig.baseUrl+'panel/permissions/storeRoutes', {
        permissions: sendResult,
        unPermissions: sendResultUnPermission,
        role: this.$route.params.role,
        organization_id : this.$route.params.id
      }).then(r => {
        this.message = {
          status: true,
          text: "success operation",
          color: r.data.status==="success" ? "success" : "error"
        }
        setTimeout(() => {
          this.message.status = false
        }, 30000)
        this.loading=false
      })
    }
  }
}
</script>

<style scoped>

</style>
